import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../../utils/API/responseMiddleware";
import { encryptAES } from "../../../services/CryptoService";
import { encryptQueryString, transformRequest } from "../../../utils/API/requestMiddleware";


const BoardCommitteeServiceApi = createApi({
    reducerPath: 'BoardCommitteeServiceApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getAllBoardCommitteeApprovalList: builder.query({
            query: (details) => ({
                url: `/BoardCommittee/GetAllBoardCommitteeApprovalList?id=${encryptAES(details.ipasMemberId)}&id2=${encryptAES(details.taskListId)}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        sendBoardCommitteeApproval: builder.mutation({
            query: (details) => ({
                url: `/BoardCommittee/SendBoardCommitteeApproval`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        resendSendBoardCommitteeApprovalMail: builder.query({
            query: (details) => ({
                url: `/BoardCommittee/ResendSendBoardCommitteeApprovalMail?id=${encryptAES(details.boardCommitteeApprovalId)}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        boardCommiteeDecisionToApprove: builder.mutation({
            query: (details) => ({
                url: `/BoardCommittee/BoardCommiteeDecisionToApprove`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        submitBoardCommitteeApproval: builder.mutation({
            query: (details) => ({
                url: `/BoardCommittee/SubmitBoardCommitteeApproval`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        rejectCommitteeBoard: builder.mutation({
            query: (details) => ({
                url: `/BoardCommittee/RejectCommitteeBoard`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getBoardCommitteeMembers: builder.query({
            query: (details) => ({
                url: `/BoardCommittee/GetBoardCommitteeMembers`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addEditBoardCommitteeMember: builder.mutation({
            query: (details) => ({
                url: `/BoardCommittee/AddEditBoardCommitteeMember`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        editBoardCommitteeMember: builder.mutation({
            query: (details) => ({
                url: `/BoardCommittee/EditBoardCommitteeMember`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteBoardCommitteeMemberById: builder.mutation({
            query: (details) => ({
                url: `/BoardCommittee/DeleteBoardCommitteeMemberById/?id=${encryptAES(details.id)}&id2=${encryptAES(details?.id2)}&id3=${encryptAES(details?.id3)}`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllManageAdmissionMemberById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/BoardCommittee/GetBoardCommitteeMemberById?id=${parseInt(id)}`),
                method: 'POST',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
    useLazyGetAllBoardCommitteeApprovalListQuery,
    useSendBoardCommitteeApprovalMutation,
    useLazyResendSendBoardCommitteeApprovalMailQuery,
    useBoardCommiteeDecisionToApproveMutation,
    useSubmitBoardCommitteeApprovalMutation,
    useRejectCommitteeBoardMutation,
    useLazyGetBoardCommitteeMembersQuery,
    useAddEditBoardCommitteeMemberMutation,
    useDeleteBoardCommitteeMemberByIdMutation,
    useGetAllBoardCommitteeApprovalListQuery
} = BoardCommitteeServiceApi;

export default BoardCommitteeServiceApi;